<template>
  <div class="hrDetail">
    <div class="crumbs">
      <crumbs> </crumbs>
    </div>
    <div class="contentBox">
      <div class="top">
        <div class="leftimg">
          <template v-if="detailsData.productDetailImg">
            <img
              :src="detailsData.productDetailImg[0].url"
              v-if="detailsData.productDetailImg.length == 1"
            />
            <el-carousel height="380px" v-else>
              <el-carousel-item
                v-for="item in detailsData.productDetailImg"
                :key="item.uid"
              >
                <img :src="item.url" alt="" />
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
        <div class="righttext">
          <a
            target="_blank"
            :href="detailsData.policyTemplate[0].url"
            v-if="
              detailsData.policyTemplate &&
                detailsData.policyTemplate.length > 0
            "
            class="policyTemplate"
          >
            <i class="el-icon-document"></i>保单模版
          </a>
          <div>
            <p>
              <i class="tit"> 产品名称：</i>
              <span>{{ detailsData.productName }}</span>
            </p>
            <p>
              <i class="tit"> 产品编号：</i>
              <span>{{ detailsData.productCode }}</span>
            </p>
            <p>
              <i class="tit"> 产品简介：</i>
              <span
                v-for="(item, index) in detailsData.productHigh"
                :key="index"
                ><img src="@/assets/images/product/anq.png" />{{ item }}</span
              >
            </p>
            <div class="ritit">
              <i class="tit"> 产品描述： </i>
              <div v-html="detailsData.desc"></div>
            </div>
          </div>
          <div>
            <p>
              <span style="color: #e46e22" v-if="isCanCommission == 1">
                佣金：{{ detailsData.proCommission }}%
              </span>
              折扣：{{ detailsData.baseMoney }}折
            </p>
            <el-button type="primary" @click="skip">
              立即投保
            </el-button>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="titbox">
          <div>投保提示</div>
          <ul>
            <li v-for="item in detailsData.occupationCate" :key="item.uid">
              <a
                :href="item.url"
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                <i class="iconfont icon-a-xiazai3"></i>下载《职业类别》
              </a>
            </li>
            <li v-for="item in detailsData.insureFile" :key="item.uid">
              <a
                :href="item.url"
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                <i class="iconfont icon-a-xiazai3"></i>下载《投保资料》
              </a>
            </li>
          </ul>
        </div>
        <div class="textbox">
          <p>
            承保年龄：<span>{{ detailsData.insureAge }}</span>
          </p>
          <p>
            保障期限：<span>{{ detailsData.insureTime }}</span>
          </p>
          <p>
            起保人数：<span>{{ detailsData.insureNum }}</span>
          </p>
          <p>
            承保职业：<span>{{ detailsData.insureWork }}</span>
          </p>
          <p>
            拒保行业：
            <span> {{ detailsData.nonInsured }} </span>
          </p>
          <p>
            拒保地区：
            <span> {{ detailsData.noInsureArea }} </span>
          </p>
          <p>
            收单时间：
            <span> {{ detailsData.endTime }} </span>
          </p>
        </div>
        <div class="tabsBox">
          <div class="tabsTit">
            <p @click="activeName = 1">
              <img
                :src="
                  activeName == 1
                    ? require('@/assets/images/product/hr_capsule_left_a.png')
                    : require('@/assets/images/product/capsule_left.png')
                "
              />
              <span :class="activeName == 1 ? 'active' : ''">产品详情</span>
            </p>
            <p @click="activeName = 2">
              <img
                :src="
                  activeName == 2
                    ? require('@/assets/images/product/hr_capsule_center_a.png')
                    : require('@/assets/images/product/capsule_center.png')
                "
              />
              <span :class="activeName == 2 ? 'active' : ''">投保须知</span>
            </p>
            <p @click="activeName = 3">
              <img
                :src="
                  activeName == 3
                    ? require('@/assets/images/product/hr_capsule_center_a.png')
                    : require('@/assets/images/product/capsule_center.png')
                "
              />
              <span :class="activeName == 3 ? 'active' : ''">保险条款</span>
            </p>
            <p @click="activeName = 4">
              <img
                :src="
                  activeName == 4
                    ? require('@/assets/images/product/hr_capsule_center_a.png')
                    : require('@/assets/images/product/capsule_center.png')
                "
              />
              <span :class="activeName == 4 ? 'active' : ''">常见问题</span>
            </p>
            <p @click="activeName = 5">
              <img
                :src="
                  activeName == 5
                    ? require('@/assets/images/product/hr_capsule_left_a.png')
                    : require('@/assets/images/product/capsule_left.png')
                "
              />
              <span :class="activeName == 5 ? 'active' : ''">理赔流程</span>
            </p>
          </div>
          <div class="tabsContent">
            <!-- 产品详情 -->
            <div class="textBox" v-show="activeName == 1">
              <div v-html="detailsData.productDesc"></div>
              <p class="tit">隐私保护声明</p>
              <div v-html="detailsData.privacyDesc"></div>
              <p class="tit">特别约定</p>
              <div v-html="detailsData.importantNotices"></div>
            </div>
            <!-- 投保须知 -->
            <div class="textBox" v-show="activeName == 2">
              <p v-for="item in detailsData.insuranceNotice" :key="item.uid">
                <a :href="item.url" target="_blank" download>
                  {{ item.name }}
                </a>
              </p>
            </div>
            <!-- 保险条款 -->
            <div class="textBox" v-show="activeName == 3">
              <p v-for="item in detailsData.insureClause" :key="item.uid">
                <a :href="item.url" target="_blank" download>
                  {{ item.name }}
                </a>
              </p>
            </div>
            <!-- 常见问题 -->
            <div class="textBox" v-show="activeName == 4">
              <div class="issue">
                <p class="issueTit">
                  <span>
                    1
                  </span>
                  本产品指定的医院范围为？
                  <i
                    class="el-icon-arrow-down"
                    @click="issue1 ? (issue1 = false) : (issue1 = true)"
                  ></i>
                </p>
                <div class="issueCon" v-show="issue1">
                  中华人民共和国卫生部门评审确定的二级或二级以上的公立医院普通部，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。
                </div>
              </div>
              <div class="issue">
                <p class="issueTit">
                  <span>
                    2
                  </span>
                  高空作业最高可承担到几米的责任？
                  <i
                    class="el-icon-arrow-down"
                    @click="issue2 ? (issue2 = false) : (issue2 = true)"
                  ></i>
                </p>
                <div class="issueCon" v-show="issue2">
                  国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。”，被保险人雇员从事高处作业时因未系绑安全带导致的保险事故属除外责任。
                </div>
              </div>
            </div>
            <!-- 理赔流程 -->
            <div class="textBox" v-show="activeName == 5">
              <div class="flow">
                <!-- <p class="flowTit">
                  <img src="@/assets/images/product/flowTitbg.png" alt="" />
                  <span>方案1</span>
                </p> -->
                <div class="flowCon">
                  <img src="@/assets/images/product/flowTitimg.png" alt="" />
                  <p class="flowHint">
                    特别提示：
                    <br />
                    1、如伤情严重需先行就医请务必到二级乙等或以上公立医院就医,理赔范围为当地医保可报销范围内用药和必要治疗手段;
                    <br />
                    2、如当天未就医请务必在48小时内尽快就医,以免耽误治疗。
                  </p>
                </div>
              </div>
              <!-- <div class="flow">
                <p class="flowTit">
                  <img src="@/assets/images/product/flowTitbg.png" alt="" />
                  <span>方案2</span>
                </p>
                <div class="flowCon">
                  <p>
                    直接拨打保险公司客服热线进行报案。此方案报案
                    后，后续事宜需您与保司沟通。
                  </p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from "@/components/common/crumbs";
import { getProductDetail } from "@/api/insure";
export default {
  name: "insureDetail",
  components: {
    crumbs
  },
  data() {
    return {
      isCanCommission: this.$store.getters.isCanCommission, //是否展示佣金
      product_id: "",
      activeName: 1, //下面选项卡
      issue1: true, //问题
      issue2: true, //问题
      detailsData: ""
    };
  },
  mounted() {
    this.product_id = this.$route.query.id;
    this.getProductDetail(); //触发请求数据
  },
  methods: {
    skip() {
      // 页面跳转
      let _url = this.$router.resolve({
        path: "/hr/insure",
        query: { id: this.product_id }
      });
      window.open(_url.href, "_blank");
    },
    up() {
      // 返回顶部
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    },
    // 获取信息
    getProductDetail() {
      let that = this;
      getProductDetail({ product_id: that.product_id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.detailsData = res.data;
            // 设置title
            document.title = "产品详情--" + res.data.productName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 保费试算关闭
    drawerClose(e) {
      this.drawerVisible = false;
    }
  }
};
</script>
<style lang="scss">
.hrDetail {
  padding: 0 !important;
  margin-top: 15px !important;
  background: #f4f5f7 !important;
  box-shadow: none !important;

  & > .crumbs {
    margin: 0 8px;
  }
  .contentBox {
    width: 100%;
    min-width: 1200px;
    .top {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      padding: 25px 0 0;
      margin-bottom: 25px;
      .leftimg {
        width: 450px;
        height: 380px;
        overflow: hidden;
        position: relative;
        background: #c4c4c4;
        border-radius: 20px 0px 0px 0px;
        img {
          vertical-align: middle;
          object-fit: cover;
          max-width: 100%;
        }
      }
      .righttext {
        height: 330px;
        background: #ffffff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
        border-radius: 4px 20px 4px 4px;
        padding: 25px 0 0 40px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        position: relative;
        flex: 1;
        & > .policyTemplate {
          background: linear-gradient(90deg, #e46e22 0%, #f59f40 100%);
          border-radius: 16px;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          position: absolute;
          top: 20px;
          right: 18px;
          padding: 7px 20px;
          i {
            margin-right: 5px;
          }
        }
        & > div {
          padding-right: 25px;
          & > p,
          .ritit {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            margin: 0;
            padding-top: 15px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            i.tit {
              font-style: normal;
              min-width: 82px;
            }
            span {
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              display: inline-block;
              margin-right: 20px;
              img {
                width: 16px;
                margin-right: 5px;
                vertical-align: text-bottom;
              }
            }
            div {
              display: inline-block;
              line-height: 1.5;
              p,
              span {
                margin: 0;
              }
            }
          }
        }
        & > div + div {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          p {
            font-size: 16px;
            font-weight: 600;
            color: #e46e22;
            padding: 0 30px;
          }
          .el-button {
            width: 220px;
            height: 64px;
            font-size: 22px;
            font-weight: 600;
            color: #ffffff;
            line-height: 30px;
            background: linear-gradient(106deg, #ffffff 0%, #fff1e3 100%);
            background-image: url("~@/assets/images/product/hrbtnbg.png");
            background-size: cover;
            border: none;
          }
        }
      }
    }
    .bottom {
      background: #ffffff;
      box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.07);
      border-radius: 0px 0px 4px 4px;
      margin-bottom: 45px;
      .titbox {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-bottom: 1px solid #97979745;
        padding-right: 20px;
        & > div {
          position: relative;
          font-size: 20px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 64px;
          padding-left: 30px;
        }
        & > div::before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 32px;
          background: #2ca063;
          border-radius: 0px 10px 10px 0px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          align-items: center;
          line-height: 64px;
          li {
            font-size: 14px;
            font-weight: 400;
            color: #2d8aee;
            margin-left: 25px;
            i {
              font-size: 14px;
              margin-right: 3px;
            }
          }
        }
      }
      .tabsBox {
        padding: 0 30px 30px;
        .tabsTit {
          display: inline-flex;
          justify-items: flex-start;
          align-items: center;
          border-radius: 16px;
          background: #fff;
          overflow: hidden;
          p {
            font-size: 14px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            margin: 0;
            position: relative;
            width: 116px;
            cursor: pointer;
            img {
              width: 100%;
              height: 32px;
              vertical-align: middle;
            }
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 100%;
              text-align: center;
              line-height: 1;
            }
            span.active {
              color: rgba(255, 255, 255, 0.85);
            }
          }
          p + p {
            margin-left: -10px;
          }
          p:last-child img {
            transform: rotate(180deg);
          }
        }
        .tabsContent {
          padding-top: 20px;
          .textBox {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.75);
            line-height: 2;
            p {
              margin: 0;
            }
            a:hover {
              color: #2d8aee;
            }
            .tit {
              font-weight: 600;
              margin-top: 20px;
              margin-bottom: 10px;
            }
            .tit:before {
              content: "";
              width: 8px;
              height: 8px;
              border: 2px solid #2ca063;
              margin-right: 10px;
              display: inline-block;
              transform: rotate(45deg);
              margin-bottom: 1px;
            }
            .issue {
              background: #ffffff;
              border: 1px solid #e2e1e1;
              margin-bottom: 30px;
              .issueTit {
                font-size: 14px;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                position: relative;
                line-height: 32px;
                padding: 8px 10px;
                span {
                  display: inline-block;
                  width: 32px;
                  height: 32px;
                  background-size: 100%;
                  background-repeat: no-repeat;
                  text-align: center;
                  vertical-align: middle;
                  color: #fff;
                  font-weight: 500;
                  line-height: 28px;
                  margin-right: 15px;
                  background-image: url("~@/assets/images/product/issue_num.png");
                }
                i {
                  position: absolute;
                  top: 50%;
                  right: 10px;
                  transform: translateY(-50%);
                  font-size: 24px;
                  font-weight: 600;
                  color: #006bff;
                  cursor: pointer;
                  padding: 10px;
                }
              }
              .issueCon {
                border-top: 1px solid #ededed;
                padding: 10px 20px 20px;
              }
            }
            .flow {
              margin-bottom: 20px;
              .flowTit {
                position: relative;
                width: 95px;
                height: 40px;
                margin-bottom: 15px;
                span {
                  font-size: 16px;
                  font-weight: 500;
                  color: #2d8aee;
                  position: absolute;
                  top: 45%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              .flowCon {
                padding-left: 4px;
                p {
                  font-size: 16px;
                  font-weight: 400;
                  color: rgba(0, 0, 0, 0.85);
                  line-height: 22px;
                }
                img {
                  max-width: 100%;
                  padding: 0 0 20px;
                }
                .flowHint {
                  font-size: 14px;
                  font-weight: 400;
                  color: #00000080;
                  line-height: 20px;
                }
              }
            }
          }
        }
      }
      .textbox {
        padding: 20px 30px 30px;
        & > p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 36px;
          margin: 0;
          display: flex;
          justify-content: flex-start;
          span {
            color: rgba(0, 0, 0, 0.85);
            max-width: calc(100% - 75px);
          }
        }
      }
    }
  }
}
</style>
